export enum MissionsBetContributionEnum {
    REAL_MONEY = 'real_money',
    REAL_MONEY_AND_BONUS_MONEY = 'real_money_and_bonus_money'
}